import React, { createContext, useContext, useEffect, useState } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserPermissions, setSelectedUserPermissions] = useState([]); // Now an array
  const [selectedUserEmail, setSelectedUserEmail] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem('selectedUser');
    const savedPermissions = localStorage.getItem('selectedUserPermissions');
    const savedEmail = localStorage.getItem('selectedUserEmail');

    if (savedEmail) setSelectedUserEmail(savedEmail);
    if (savedUser) setSelectedUser(savedUser);
    if (savedPermissions) {
      try {
        setSelectedUserPermissions(JSON.parse(savedPermissions));
      } catch {
        setSelectedUserPermissions([]);
      }
    }
  }, []);

  // Helper function to check if user has a specific permission
  const hasPermission = (permission) => {
    return selectedUserPermissions.includes(permission);
  };

  // Helper function to check if user has any of the specified permissions
  const hasAnyPermission = (permissions) => {
    return permissions.some(p => selectedUserPermissions.includes(p));
  };

  return (
    <UserContext.Provider
      value={{
        selectedUser,
        selectedUserEmail,
        setSelectedUser,
        selectedUserPermissions,
        setSelectedUserPermissions,
        hasPermission,
        hasAnyPermission,
        // Legacy support - returns first permission or null
        selectedUserPermission: selectedUserPermissions[0] || null,
        setSelectedUserPermission: (perm) => setSelectedUserPermissions(perm ? [perm] : []),
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
